import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &.", " {\n    display: inline-flex;\n    max-width: ", ";\n    overflow: hidden;\n    .", " {\n      overflow: hidden;\n      white-space: nowrap;\n      /* \u662F\u5426\u901A\u8FC7css\u6765\u6E32\u67D3\u7701\u7565\u7B26 */\n      ", "\n    }\n    .", " {\n      flex: 0 0 auto;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { mainClassName, omissionClassName, baseClassName } from './constants';

var FilteredSpan = function FilteredSpan(_ref) {
  var threshold = _ref.threshold,
      omissionByCSS = _ref.omissionByCSS,
      rest = _objectWithoutProperties(_ref, ["threshold", "omissionByCSS"]);

  return React.createElement("span", rest);
};

export var STruncateWidthContainer = styled(FilteredSpan)(_templateObject(), baseClassName, function (_ref2) {
  var threshold = _ref2.threshold;
  return typeof threshold === 'number' ? "".concat(threshold, "px") : threshold;
}, mainClassName, function (_ref3) {
  var omissionByCSS = _ref3.omissionByCSS;
  return omissionByCSS ? 'text-overflow: ellipsis;' : '';
}, omissionClassName);
export var SWrapper = styled.span(_templateObject2());